import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import "./index.css";
import { Button, } from "antd";

import { LoginStore } from "../../store";
import { useLogto } from "@logto/react";

if (process.env.REACT_APP_ENV === "prod") {
  LoginStore.redirectUrl = "https://ydh-portal.118114.net/";
  LoginStore.config = {
    endpoint: "https://capybara-sso.118114.net",
    appId: "7v1el6z92obs2ciifzp8u",
  };
} else if (process.env.REACT_APP_ENV === "develop") {
  LoginStore.redirectUrl = "https://business-customer-portal-web.192-168-29-75.yxh.wiki/";
  //本地
  // LoginStore.redirectUrl = "http://localhost:3000/";
  //lkf
  // LoginStore.redirectUrl = 'https://business-customer-platform-portal-x-lkf-240815-reset-apool.192-168-29-75.yxh.wiki/'
  // LoginStore.redirectUrl = 'https://enterprise-portal-web-x-wgy-portal-video-audit-ai.192-168-29-75.yxh.wiki/'
  LoginStore.config = {
    endpoint: "https://logto.192-168-38-231.yxh.wiki",
    appId: "0yr6wou41zgicn5jsvgb6",
  };
} else {
  LoginStore.redirectUrl = "https://business-customer-portal-web-uat.10-146-28-43.yxh.wiki/";
  LoginStore.config = {
    endpoint: "https://uat-logto.10-146-28-43.yxh.wiki/",
    appId: "5bamhqo8e1im8zs90vi0w",
  };
}

function LoginButton(props:any) {
  const { signIn } = useLogto();

  return (
    // 组件的内容
    <div className="loginPage">
      <div className="loginContent">
        <div className="loginTitle">欢迎登录企业门户</div>
        <Button
          type="primary"
          htmlType="submit"
          className="ssoButton"
          onClick={() => signIn(
            LoginStore.redirectUrl
            )}
        >
          登录
        </Button>
      </div>
    </div>
  );
}

function Login() {


  return (
    <Fragment>
        <LoginButton />
    </Fragment>
  )
}

export default observer(Login);
